module.exports = __webpack_public_path__ + "static/img/logo12.190227dd.png";